<div class="shift-compliance-container">
	<h1 class="shift-compliance-header">Our Leadership Team</h1>
	<p class="shift-compliance-para">
		We are compliance experts with over 50 years of combined executive
		<br class="d-none d-sm-block" />
		experience in highly regulated industries. We have brought our
		<br class="d-none d-sm-block" />
		collective experience to bear on solving the most difficult and complex
		<br class="d-none d-sm-block" />
		compliance problems facing all companies - from small businesses to
		<br class="d-none d-sm-block" />
		large scale multi-national corporations and government agencies.
	</p>
</div>
